export default "__VITE_ASSET__BP5jPjs2__"